// extracted by mini-css-extract-plugin
module.exports = {"leadCopy":"leadCopy-module--lead-copy--2mrl3"};